import { useState, useCallback } from 'react';
import { DriveFile } from '../services/myDriveService';

export function useFileSelection(files: DriveFile[]) {
  const [selected, setSelected] = useState<Set<number>>(new Set());
  const [lastClicked, setLastClicked] = useState<number | null>(null);

  const onItemClick = useCallback((id: number, ev: React.MouseEvent) => {
    if (ev.ctrlKey || ev.metaKey) {
      setSelected(prev => {
        const next = new Set(prev);
        if (next.has(id)) next.delete(id); else next.add(id);
        return next;
      });
      setLastClicked(id);
    } else if (ev.shiftKey && lastClicked !== null) {
      const idx1 = files.findIndex(f => f.id === lastClicked);
      const idx2 = files.findIndex(f => f.id === id);
      const [lo, hi] = idx1 < idx2 ? [idx1, idx2] : [idx2, idx1];
      setSelected(new Set(files.slice(lo, hi + 1).map(f => f.id)));
    } else {
      setSelected(new Set([id]));
      setLastClicked(id);
    }
  }, [files, lastClicked]);

  const clear = useCallback(() => setSelected(new Set()), []);

  return { selected, onItemClick, clear };
}
